import { memo, useEffect } from 'react';
import { Outlet, useParams, useNavigate, useLocation } from 'react-router';
import { supportedLocales, locale as defaultLocale } from '@/i18n';

function LngRoot() {
  const navigate = useNavigate();
  const { lng } = useParams();
  const location = useLocation();

  useEffect(() => {
    if (
      lng &&
      !supportedLocales.includes(lng as (typeof supportedLocales)[number])
    ) {
      /**
       * replace lng param and maintain current URL
       */
      const { pathname, search, hash } = location;
      const fixedPath = pathname.replace(
        new RegExp(`^/${lng}(?=/|$)`),
        `/${defaultLocale}`
      );
      const navigateTo = `${fixedPath}${search ?? ''}${hash ?? ''}`;
      // eslint-disable-next-line no-console
      console.log(
        `language(${lng}) not in the supported locales, redirecting to: `,
        navigateTo
      );
      navigate(navigateTo, { replace: true });
    }
  }, [lng, location, navigate]);

  return <Outlet />;
}

const LngRootMemo = memo(LngRoot);
LngRootMemo.displayName = 'LngRoot';

export default LngRootMemo;
